import type { EditControlProps } from '../../declare'
import { useMemo } from 'react'
import { DatePicker } from 'src/components'
import { CONTROL_TYPE_mapto_DATE_TYPE } from 'src/components/root/helper'

const DateControl = (props: EditControlProps) => {
  const handleChange = (value: any) => {
    props.onChange?.(value)
  }

  const dateType = useMemo(() => {
    return CONTROL_TYPE_mapto_DATE_TYPE(props.config.CONTROL_TYPE)
  }, [props.config.CONTROL_TYPE])

  const { __READONLY__, EDITABLE } = props.config
  return (
    <DatePicker
      disabled={__READONLY__ || !EDITABLE || props.evtConfig?.disabled}
      value={props.value}
      dateType={dateType}
      onChange={handleChange}
    />
  )
}

export default DateControl